export class FlexLayoutItemConfig {
    col?: number;
    row?: number;
    flex?: string;
    layoutAlign?: string;
    class?: string;
    width?: number;
    minWidth?: number;
    maxWidth?: number;
}
